"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormTitleWrapper = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _qa = require("../../utils/qa");
var _Icon = require("../Icon");
var _FormTitleWrapperModule = _interopRequireDefault(require("./FormTitleWrapper.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const FormTitleWrapper = exports.FormTitleWrapper = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    classNames,
    iconType,
    iconName,
    iconSize = 'small',
    iconColor,
    title,
    rightSlot,
    testId
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ref: ref,
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'root'
    }),
    className: _FormTitleWrapperModule.default.container,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: (0, _classify.default)(_FormTitleWrapperModule.default.leftSection, classNames?.wrapper),
      "data-testid": (0, _qa.generateTestId)({
        base: testId,
        slot: 'left'
      }),
      children: [!!iconName && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        type: iconType,
        name: iconName,
        size: iconSize,
        color: iconColor,
        testId: (0, _qa.generateTestId)({
          base: testId,
          slot: 'icon'
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _classify.default)(_FormTitleWrapperModule.default.componentHousing, classNames?.title),
        "data-testid": (0, _qa.generateTestId)({
          base: testId,
          slot: 'title'
        }),
        children: title
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _classify.default)(_FormTitleWrapperModule.default.rightSection, classNames?.rightSlot),
      "data-testid": (0, _qa.generateTestId)({
        base: testId,
        slot: 'right'
      }),
      children: rightSlot
    })]
  });
});